import useAPI from '@/pages/members/hooks/useAPI';
import AppointmentsRepository from '@/repositories/members/AppointmentsRepository';

export const useAppointment = (id: string | undefined, enabled: boolean = true) => {
  const appointmentsRepository = AppointmentsRepository();

  return useAPI({
    queryKey: ['appointment', id],
    queryFn: async () => {
      return await appointmentsRepository.getAppointment(id!);
    },
    enabled: enabled && !!id
  });
};
